<template>
  <div class="read-text">
    <navigator :items="items"></navigator>
    <div class="container">
      <div class="row">
        <div class="col-12">
          <div class="card">
            <div class="container-fluid">
              <div class="row filter-row">
                <div class="col-12">
                  <div class="content-title-governet">
                    {{
                      text.index.name +
                      (text.sub_index ? ` / ${text.sub_index.name}` : "")
                    }}
                  </div>
                </div>
              </div>
              <div class="row" id="search-highlited">
                <div class="col-12 title-text">
                  <span>{{ text.title }}</span>
                </div>
                <div class="col-12">
                  <div class="authors-desc-list" v-if="text.authors.length > 0">
                    <div
                      class="author-desc"
                      v-for="author in text.authors"
                      v-bind:key="author.id"
                    >
                      <div v-if="author.foto_url" class="author-image">
                        <img
                          v-if="author.foto_url"
                          :src="author.foto_url"
                          alt
                        />
                      </div>
                      <span v-bind:class="{ authorMargin: !author.foto_url }">
                        <b class="author-name">{{ author.name }}</b>
                        <br />
                        {{ author.qualification }}
                        <br />
                        <span v-if="author.site_url">
                          Site:
                          <a
                            :href="getLink(author.site_url)"
                            target="_blank"
                            rel="noopener noreferrer"
                            >{{ author.site_url }}</a
                          >
                        </span>
                      </span>
                    </div>
                  </div>
                  <div v-html="text.content" class="text-content"></div>
                  <div class="text-details">
                    <div class="date">
                      Data de publicação:
                      {{
                        formatDate(
                          text.publish_date
                            ? text.publish_date
                            : text.created_at
                        )
                      }}
                    </div>
                  </div>
                  <div class="text-details">
                    <div
                      class="date"
                      v-for="magazine in text.magazines"
                      v-bind:key="magazine.id"
                    >
                      <div
                        class="date"
                        v-for="magazine_editions in text.magazine_editions"
                        v-bind:key="magazine_editions.id"
                      >
                        <div
                          v-if="magazine.id == magazine_editions.magazine_id"
                        >
                          {{ magazine.name != null ? magazine.name : "" }} -
                          {{
                            magazine_editions.created_at != null
                              ? formatDateNumberToName(
                                  magazine_editions.created_at
                                )
                              : ""
                          }}
                          nº
                          {{
                            magazine_editions.edition_number != null
                              ? magazine_editions.edition_number
                              : ""
                          }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-12">
                  <button
                    class="btn btn-primary float-right"
                    style="margin-top: 12px"
                    v-on:click="exportPDF()"
                  >
                    Exportar como PDF
                  </button>
                </div>
              </div>
              <div class="row send-email">
                <send-item-email
                  title="Envie esse texto por email"
                  :item_id="text_id"
                  message_field
                  url="send_text_email"
                ></send-item-email>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "@/api/axios";
import Swal from "sweetalert2";
import moment from "moment";
import SendItemEmail from "@/components/forms/SendItemEmail";
import { bus } from "@/main";

export default {
  name: "read-text",
  props: {
    text_id: Number,
  },
  components: {
    SendItemEmail,
  },
  data() {
    return {
      text: {},
      items: [
        {
          text: "Banco de Dados",
          route: "public.search-texts",
        },
        {
          text: "Resultado da pesquisa",
          active: true,
        },
      ],
    };
  },
  mounted() {
    if (this.text_id) {
      this.getDataObject(this.text_id);
    } else {
      if (this.$route.query.text_id) {
        this.text_id = this.$route.query.text_id;
        this.getDataObject(this.text_id);
      } else {
        this.$router.push({ name: "Home" });
      }
    }
  },
  methods: {
    getDataObject: function (id) {
      bus.$emit("changeLoading", true);
      axios
        .get(`${process.env.VUE_APP_API_HOST}/api/texts/${id}`)
        .then((response) => {
          if (response.data.error) {
            bus.$emit("changeLoading", false);
            Swal.fire({
              title: "Você não tem acesso a esse conteúdo",
              icon: "info",
              onClose: () => {
                this.$router.push({ name: "public.search-texts" });
              },
            });
          } else {
            var text = response.data.content;

            if (localStorage.getItem("filters_search") != "") {
              var data = JSON.parse(localStorage.getItem("filters_search"));
              let words = data.filter.description;

              text = this.markSearchedWords(words, text);
            }

            response.data.content = text;
            this.text = response.data;
            this.incrementAccess(this.text.id);
            bus.$emit("changeLoading", false);
          }
        });
    },
    incrementAccess: function (id) {
      axios
        .post(`${process.env.VUE_APP_API_HOST}/api/text_access/${id}`)
        .then((response) => {});
    },
    formatDate: function (date) {
      return moment(date).format("DD/MM/YYYY");
    },
    formatDateNumberToName: function (date) {
      return moment(date).lang("pt-br").format("MMMM YYYY");
    },
    exportPDF: function () {
      bus.$emit("changeLoading", true);
      axios
        .get(
          `${process.env.VUE_APP_API_HOST}/api/generate_pdf_text/${this.text.id}`,
          {
            responseType: "blob",
          }
        )
        .then((response) => {
          this.download(`${this.text.title}.pdf`, response.data);
          bus.$emit("changeLoading", false);
        });
    },
    getLink: function (link) {
      if (link.includes("http")) {
        return link;
      }

      return `http://${link}`;
    },
    download: function (filename, data) {
      const url = window.URL.createObjectURL(new Blob([data]));
      const link = document.createElement("a");
      console.log(link);
      link.href = url;

      link.setAttribute("download", filename);
      document.body.appendChild(link);
      link.click();
    },
    markSearchedWords: function (words, text) {
      let expression = words.includes('"');

      if (expression) {
        var words_expression = [...words.matchAll(/"[^"]+"/gi)];
        words = words.replaceAll(/"[^"]+"/gi, "");
      }

      words = words.split(" ");

      for (let word of words) {
        if (word != "" && word.length > 3) {
          let regex = new RegExp(`(?<!<[^>]*)${word}(?<![^>]*<)`, "gi");
          text = text.replace(
            regex,
            function (match) {
              return this.matchCase(word, match);
            }.bind(this)
          );
        }
      }

      if (expression) {
        for (let word of words_expression) {
          let word_search = word[0].replace(/"/g, "");
          let regex = new RegExp(`(?<!<[^>]*)${word_search}(?<![^>]*<)`, "gi");
          if (word_search != "") {
            text = text.replace(
              regex,
              function (match) {
                return this.matchCase(word_search, match);
              }.bind(this)
            );
          }
        }
      }

      return text;
    },
    matchCase: function (text, pattern) {
      var result = "";

      for (var i = 0; i < text.length; i++) {
        var c = text.charAt(i);
        var p = pattern.charCodeAt(i);

        if (p >= 65 && p < 65 + 26) {
          result += c.toUpperCase();
        } else {
          result += c.toLowerCase();
        }
      }

      return `<mark class="color-mark">${result}</mark>`;
    },
  },
};
</script>

<style lang="scss">
@import "@/styles/General.scss";
.read-text {
  .title-text {
    font-size: 30px;
  }
  .text-content {
    padding-top: 3vh;
    padding-bottom: 3vh;
  }
  .authors-desc-list {
    background-color: #f5f5f5;
    padding: 12px 8px;
    .authorMargin {
      margin-left: 95px;
    }
    .author-desc {
      display: flex;
      margin-bottom: 15px;
      margin-top: 15px;
      height: fit-content;
      .author-image {
        margin: 8px 12px;
        width: 6vw;
        height: fit-content;
        display: flex;
        justify-content: center;
        img {
          max-height: 90px;
          width: 70px;
        }
      }
      a {
        text-decoration: none;
        color: #5f6064;
      }
    }
  }
  .text-details {
    font-size: 14px;
    color: #5f6064;
  }
  .send-email {
    padding-top: 1.5vh;
  }
  .color-mark {
    background-color: #e10d0d80;
  }
}
</style>